import { Box, Text } from '@chakra-ui/react';

import { Glyph } from '~/components/glyph';
import { Modal } from '~/components/modal';

export type EnterpriseResourceFormProps = {
  title: string;
  message: string;
  state: 'success' | 'error';
  date?: string | null;
  time?: string;
  isOpen: boolean;
  onClose: () => void;
};

export function EnterpriseResourceRegistrationModal({
  title,
  message,
  state,
  date,
  time,
  isOpen,
  onClose,
}: EnterpriseResourceFormProps) {
  return (
    <Modal isOpen={isOpen} size='3xl' title={title} onClose={onClose}>
      <Glyph name={state === 'success' ? 'checkmark-medal-two' : 'alert-one'} />

      <Text marginBottom='8px' marginTop='16px'>
        {message}
      </Text>

      {date && (
        <Box>
          <Text display='inline-block' fontWeight='bold'>
            Date:
          </Text>{' '}
          <Text display='inline-block'>{date}</Text>
        </Box>
      )}

      {time && (
        <Box>
          <Text display='inline-block' fontWeight='bold'>
            Time:
          </Text>{' '}
          <Text display='inline-block'>{time}</Text>
        </Box>
      )}
    </Modal>
  );
}
